export default __webpack_public_path__ + "static/media/norbert-baumann-sonnen.2aba7541.png";